import { useState } from 'react'
import { EditableCellProps } from './types'
import { useOutsideClick } from 'ui/hooks/useOutsideClick'
import { Typography } from 'ui/atoms/Typography'
import { joinClasses } from 'utils/joinClasses'
import styles from './styles.module.scss'
import { onlyNumbersWithOneDotRegex } from 'constants/regex'

export const OldEditableCell = ({
  initValue,
  readOnly,
  handleUpdate,
  onChange,
}: EditableCellProps) => {
  const [clicked, setClicked] = useState(false)
  const [valueRef, setValueRef] = useState<HTMLDivElement | null>(null)
  const [value, setValue] = useState<string | number>(initValue)

  useOutsideClick(valueRef, () => {
    setClicked(false)
    if (!value) {
      setValue(0)
    }
    onChange(Number(value || 0))
  })

  const handleChangeValue = (value: string) => {
    const newValue = value.replace(onlyNumbersWithOneDotRegex, '')
    if (value === newValue) {
      handleUpdate()
    }
    setValue(newValue)
  }

  return (
    <div>
      {clicked && !readOnly ? (
        <input
          ref={setValueRef}
          value={value}
          className={joinClasses(styles['value-input'], styles['Subtitle7'])}
          onChange={(e) => handleChangeValue(e.target.value)}
          autoFocus
        />
      ) : (
        <Typography
          onClick={() => setClicked(!clicked)}
          name="Subtitle7"
          Tag="div"
          className={styles.value}
          color={readOnly ? 'blackMaster' : 'blue700'}
        >
          {value}
        </Typography>
      )}
    </div>
  )
}
